import { render } from "./FormPhotoWheel.vue?vue&type=template&id=4778bc5f"
import script from "./FormPhotoWheel.vue?vue&type=script&lang=js"
export * from "./FormPhotoWheel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__